import React from "react";
import { ReactComponent as SpinnerSvg } from "./Spinner.svg";
import styles from "./Spinner.scss";
import classNames from "classnames";

export function Spinner({ className }) {
  return (
    <progress
      className={classNames(
        className,
        "tw-progress",
        "tw-h-3",
        "tw-bg-[#ffffff]/80",
        "tw-border-2",
        "tw-border-solid",
        "tw-border-[#ffffff]/80"
      )}
    />
  );
}
